import { useTranslation } from "react-i18next";
import { LucideIcon } from "lucide-react";
import { SOLUTION_GROUPS, groupPath, itemPath, useSolutionTitles } from "../Solucao/content";

export type Specialty = {
  key: string;
  title: string;
  text: string;
  to: string;
};

// Especialidades da Home e coluna "Soluções" do rodapé. serviceId = slug do tópico (/solucoes/:slug) mais próximo.
const SPECIALTIES_CONFIG = [
  { key: "gcloud", serviceId: "coreinfra", title: "Google Cloud", text: "Arquitetura, migração e operação de ambientes seguros e escaláveis." },
  { key: "workspace_edu", serviceId: "smart-learning", title: "Google Workspace para Educação", text: "Colaboração, segurança e gestão para instituições de ensino." },
  { key: "data_ai", serviceId: "cloudwork", title: "Dados e IA", text: "BigQuery, Looker, Vertex AI e soluções para transformar dados em valor." },
  { key: "security", serviceId: "shield", title: "Segurança e Governança", text: "Conformidade, DLP e identidade para o setor público." },
  { key: "managed", serviceId: "expertcare", title: "Serviços Gerenciados", text: "Suporte, operação e evolução contínua com time especializado." },
  { key: "connectivity", serviceId: "netwise", title: "Conectividade & Data Center", text: "Ambientes de alta disponibilidade para missão crítica." },
];

export function useSpecialties(): Specialty[] {
  const { t } = useTranslation();

  return SPECIALTIES_CONFIG.map(({ key, serviceId, title, text }) => ({
    key,
    title: t(`home.specialties.${key}.title`, title),
    text: t(`home.specialties.${key}.text`, text),
    to: `/solucoes/${serviceId}`,
  }));
}

export type SolutionGroup = {
  key: string;
  title: string;
  icon: LucideIcon;
  to: string;
  items: { key: string; label: string; to: string }[];
};

// Menu "Soluções" do header: um tópico por página /solucoes/:grupo, com os itens (/solucoes/:grupo/:item).
export function useSolutionGroups(): SolutionGroup[] {
  const { groupTitle, itemTitle } = useSolutionTitles();

  return SOLUTION_GROUPS.map((group) => ({
    key: group.key,
    title: groupTitle(group),
    icon: group.icon,
    to: groupPath(group),
    items: group.items.map((item) => ({ key: item.key, label: itemTitle(group, item), to: itemPath(group, item) })),
  }));
}
